export default function VPNShowcase() {
  const platforms = [
    { name: 'macOS', icon: 'ri-apple-fill' },
    { name: 'iOS', icon: 'ri-smartphone-line' },
    { name: 'iPad', icon: 'ri-tablet-line' }
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="vpn" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-16">
          <div className="flex-1">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-teal-100 to-purple-100 rounded-3xl transform rotate-3"></div>
              <div className="relative bg-white rounded-3xl p-4 shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-300">
                <img
                  src="https://public.readdy.ai/ai/img_res/961a13a41db842cc6463fb72d10da0d2.jpg"
                  alt="VPN Interface"
                  className="w-full h-auto rounded-2xl"
                />
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="inline-block bg-purple-100 px-4 py-2 rounded-full mb-6">
              <span className="text-purple-700 text-sm font-medium">// VPN SOLUTION</span>
            </div>
            
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Seamless Connection<br />
              Across All Devices
            </h2>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              STRADE VPN works flawlessly on all your devices. Whether you're on 
              your desktop, laptop, tablet, or smartphone, enjoy the same level of 
              security and performance. One subscription protects all your devices 
              with unlimited simultaneous connections.
            </p>

            <div className="mb-8">
              <p className="text-sm font-semibold text-gray-700 mb-4">SUPPORTED PLATFORMS</p>
              <div className="flex items-center gap-4">
                {platforms.map((platform, index) => (
                  <div
                    key={index}
                    className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-xl hover:bg-teal-100 transition-colors group cursor-pointer"
                    title={platform.name}
                  >
                    <i className={`${platform.icon} text-2xl text-gray-700 group-hover:text-teal-600`}></i>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={() => scrollToSection('contact')}
              className="bg-teal-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-700 transition-colors flex items-center gap-2 group whitespace-nowrap"
            >
              Learn More
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
